import React, { useEffect } from 'react'; // Import useEffect
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  useMediaQuery,
  useTheme,
  Box,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import HomeIcon from '@mui/icons-material/Home';
import AssignmentIcon from '@mui/icons-material/Assignment';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import logo from '../assets/femizero-logo.png';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  // Automatically close the drawer when the screen size changes to larger devices
  useEffect(() => {
    if (!isMobile) {
      setMobileOpen(false);
    }
  }, [isMobile]);

  const drawer = (
    <div>
      {/* Close Button */}
      <IconButton
        onClick={handleDrawerToggle}
        sx={{ position: 'absolute', right: 8, top: 8, color: 'inherit' }}
      >
        <CloseIcon />
      </IconButton>

      {/* Navigation Items with Icons */}
      <List sx={{ mt: 10 }}> {/* Increased margin-top */}
        <ListItem button key="Home" component={Link} to="/" onClick={handleDrawerToggle}>
          <ListItemIcon>
            <HomeIcon />
          </ListItemIcon>
          <ListItemText primary="Home" />
        </ListItem>
        <ListItem button key="Report Incident" component={Link} to="/report" onClick={handleDrawerToggle}>
          <ListItemIcon>
            <AssignmentIcon />
          </ListItemIcon>
          <ListItemText primary="Report Incident" />
        </ListItem>
        <ListItem button key="Resources" component={Link} to="/resources" onClick={handleDrawerToggle}>
          <ListItemIcon>
            <LibraryBooksIcon />
          </ListItemIcon>
          <ListItemText primary="Resources" />
        </ListItem>
        <ListItem button key="Support" component={Link} to="/support" onClick={handleDrawerToggle}>
          <ListItemIcon>
            <HeadsetMicIcon />
          </ListItemIcon>
          <ListItemText primary="Support" />
        </ListItem>
      </List>
    </div>
  );

  return (
    <>
      {/* Fixed Header */}
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Toolbar>
          <Typography component="div" sx={{ flexGrow: 1 }}>
            {/* Clickable Logo */}
            <Link to="/" style={{ textDecoration: 'none', flexGrow: 1 }}>
              <img
                src={logo}
                alt="FemiZero Logo"
                style={{ height: '80px', marginRight: '10px' }}
              />
            </Link>
          </Typography>
          {isMobile ? (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="end"
              onClick={handleDrawerToggle}
            >
              <MenuIcon />
            </IconButton>
          ) : (
            <>
              <Button color="inherit" component={Link} to="/" startIcon={<HomeIcon />}>
                Home
              </Button>
              <Button color="inherit" component={Link} to="/report" startIcon={<AssignmentIcon />}>
                Report Incident
              </Button>
              <Button color="inherit" component={Link} to="/resources" startIcon={<LibraryBooksIcon />}>
                Resources
              </Button>
              <Button color="inherit" component={Link} to="/support" startIcon={<HeadsetMicIcon />}>
                Support
              </Button>
            </>
          )}
        </Toolbar>
      </AppBar>

      {/* Drawer for Mobile */}
      <Drawer anchor="left" open={mobileOpen} onClose={handleDrawerToggle}>
        {drawer}
      </Drawer>

      {/* Main Content with Padding to Avoid Overlapping */}
      <Box component="main" sx={{ flexGrow: 1, p: 3, marginTop: '64px' }}>
        {/* Your main content goes here */}
      </Box>
    </>
  );
};

export default Navbar;